/* eslint-disable @typescript-eslint/no-var-requires */
export const phoenixCobrandECMQuery = require('./lib/loyaltyInformation.graphql');
export const phoenixCobrandECMMemberDetailsQuery = require('./lib/phoenixCobrandECMMemberDetails.graphql');
